import { WizardStateMachineInterface } from '../../../../wizard/interfaces/wizard-state-machine';
import { WizardStepMeta } from '../../../../wizard/interfaces/wizard-step';
import { useStateMachine } from '../../../../wizard/hooks/useStateMachine';
import { CreatePipelineStepPaths } from '../interfaces/create-pipeline-step-paths';
import { CreatePipelineSelectSourceType } from '../../components/CreatePipelineSelectSourceType/CreatePipelineSelectSourceType';
import { CreatePipelineSourceSettings } from '../../components/CreatePipelineSourceSettings/CreatePipelineSourceSettings';
import { CreatePipelineSelectDestinationType } from '../../components/CreatePipelineSelectDestinationType/CreatePipelineSelectDestinationType';
import { CreatePipelineDestinationSettings } from '../../components/CreatePipelineDestinationSettings/CreatePipelineDestinationSettings';
import { CreatePipelineSettings } from '../../components/CreatePipelineSettings/CreatePipelineSettings';
import { CreatePipelineConfigureObjects } from '../../components/CreatePipelineConfigureObjects/CreatePipelineConfigureObjects';
import {
  EntityWizardEntitySubmit,
  EntityWizardSelectEntity
} from '../../../../shared/components/EntityWizardFooterComponents/EntityWizardFooterComponents';
import { CreatePipelineReview } from '../../components/CreatePipelineReview/CreatePipelineReview';

export function useCreatePipelineStateMachine(): WizardStateMachineInterface {
  const steps: WizardStepMeta[] = [
    {
      path: CreatePipelineStepPaths.SELECT_SOURCE_TYPE,
      component: CreatePipelineSelectSourceType,
      footerComponent: EntityWizardSelectEntity,
      getNextStep: () => {
        return CreatePipelineStepPaths.SOURCE_CONNECTION_SETTINGS;
      }
    },
    {
      path: CreatePipelineStepPaths.SOURCE_CONNECTION_SETTINGS,
      component: CreatePipelineSourceSettings,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => {
        return CreatePipelineStepPaths.SELECT_DESTINATION_TYPE;
      }
    },
    {
      path: CreatePipelineStepPaths.SELECT_DESTINATION_TYPE,
      component: CreatePipelineSelectDestinationType,
      footerComponent: EntityWizardSelectEntity,
      getNextStep: () => {
        return CreatePipelineStepPaths.DESTINATION_CONNECTION_SETTINGS;
      }
    },
    {
      path: CreatePipelineStepPaths.DESTINATION_CONNECTION_SETTINGS,
      component: CreatePipelineDestinationSettings,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => {
        return CreatePipelineStepPaths.PIPELINE_SETTINGS;
      }
    },
    {
      path: CreatePipelineStepPaths.PIPELINE_SETTINGS,
      component: CreatePipelineSettings,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => {
        return CreatePipelineStepPaths.CONFIGURE_OBJECTS;
      }
    },
    {
      path: CreatePipelineStepPaths.CONFIGURE_OBJECTS,
      component: CreatePipelineConfigureObjects,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => {
        return CreatePipelineStepPaths.REVIEW;
      }
    },
    {
      path: CreatePipelineStepPaths.REVIEW,
      component: CreatePipelineReview,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => {
        return undefined;
      }
    }
  ];

  const getInitialPath = () => {
    return CreatePipelineStepPaths.SELECT_SOURCE_TYPE;
  };

  return useStateMachine({ steps, getInitialPath });
}
